import {
  BookmarkPlus,
  BookOpen,
  BrainCircuit,
  Cloud,
  FilePen,
  FilePlus,
  FileSearch,
  FileText,
  FolderPlus,
  Globe,
  GraduationCap,
  ImagePlus,
  LifeBuoy,
  MousePointerClick,
  Search,
  Server,
  ShieldCheck,
  Workflow,
} from "@/components/icons"

export type ToolName =
  | "web_search"
  | "web_scrape"
  | "library_search"
  | "file_search"
  | "microsoft_365_search"
  | "service_desk"
  | "netbox"
  | "x_one"
  | "image_generation"
  | "training_content"
  | "doc_creator"
  | "doc_updater"
  | "doc_content_reader"
  | "doc_internal_search"
  | "workflow_edit"
  | "create_saved_prompt"
  | "create_project"
  | "memory_search"

export type ToolMetadata = {
  icon: React.ReactNode
  translationKey: string
}

export const TOOL_METADATA: Record<ToolName, ToolMetadata> = {
  web_search: {
    icon: <Globe className="text-primary/40 size-4 shrink-0" strokeWidth={1.5} />,
    translationKey: "web_search",
  },
  web_scrape: {
    icon: <MousePointerClick className="text-primary/40 size-4 shrink-0" strokeWidth={1.5} />,
    translationKey: "web_scrape",
  },
  library_search: {
    icon: <BookOpen className="text-primary/40 size-4 shrink-0" strokeWidth={1.5} />,
    translationKey: "library_search",
  },
  file_search: {
    icon: <FileSearch className="text-primary/40 size-4 shrink-0" strokeWidth={1.5} />,
    translationKey: "file_search",
  },
  microsoft_365_search: {
    icon: <Cloud className="text-primary/40 size-4 shrink-0" strokeWidth={1.5} />,
    translationKey: "microsoft_365_search",
  },
  service_desk: {
    icon: <LifeBuoy className="text-primary/40 size-4 shrink-0" strokeWidth={1.5} />,
    translationKey: "service_desk",
  },
  netbox: {
    icon: <Server className="text-primary/40 size-4 shrink-0" strokeWidth={1.5} />,
    translationKey: "netbox",
  },
  x_one: {
    icon: <ShieldCheck className="text-primary/40 size-4 shrink-0" strokeWidth={1.5} />,
    translationKey: "x_one",
  },
  image_generation: {
    icon: <ImagePlus className="text-primary/40 size-4 shrink-0" strokeWidth={1.5} />,
    translationKey: "image_generation",
  },
  training_content: {
    icon: <GraduationCap className="text-primary/40 size-4 shrink-0" strokeWidth={1.5} />,
    translationKey: "training_content",
  },
  doc_creator: {
    icon: <FilePlus className="text-primary/40 size-4 shrink-0" strokeWidth={1.5} />,
    translationKey: "doc_creator",
  },
  doc_updater: {
    icon: <FilePen className="text-primary/40 size-4 shrink-0" strokeWidth={1.5} />,
    translationKey: "doc_updater",
  },
  doc_content_reader: {
    icon: <FileText className="text-primary/40 size-4 shrink-0" strokeWidth={1.5} />,
    translationKey: "doc_content_reader",
  },
  doc_internal_search: {
    icon: <Search className="text-primary/40 size-4 shrink-0" strokeWidth={1.5} />,
    translationKey: "doc_internal_search",
  },
  workflow_edit: {
    icon: <Workflow className="text-primary/40 size-4 shrink-0" strokeWidth={1.5} />,
    translationKey: "workflow_edit",
  },
  create_saved_prompt: {
    icon: <BookmarkPlus className="text-primary/40 size-4 shrink-0" strokeWidth={1.5} />,
    translationKey: "create_saved_prompt",
  },
  create_project: {
    icon: <FolderPlus className="text-primary/40 size-4 shrink-0" strokeWidth={1.5} />,
    translationKey: "create_project",
  },
  memory_search: {
    icon: <BrainCircuit className="text-primary/40 size-4 shrink-0" strokeWidth={1.5} />,
    translationKey: "memory_search",
  },
}

export function getToolMetadata(toolName: string): ToolMetadata | null {
  return (
    TOOL_METADATA[toolName as ToolName] || null // eslint-disable-line @typescript-eslint/no-unnecessary-condition
  )
}
